import type { ComponentProps } from 'react';

const Help = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 12.9757C11.5688 12.9757 11.2188 13.3267 11.2188 13.7597C11.2188 14.1909 11.5352 14.5437 12 14.5437C12.4648 14.5437 12.7812 14.1927 12.7812 13.7597C12.7812 13.2932 12.4297 12.9757 12 12.9757ZM19.5 2H4.5C3.12305 2 2 3.12697 2 4.47346V15.7275C2 17.1779 3.12305 18.2715 4.5 18.2715H8.25V21.5289C8.25 21.9146 8.68086 22.1365 8.99687 21.9072L13.875 18.2715H19.5C20.877 18.2715 22 17.1445 22 15.798V4.47346C22 3.12697 20.8789 2 19.5 2ZM20.75 15.798C20.75 16.488 20.1875 17.0524 19.5 17.0524H13.8711C13.6005 17.0524 13.3371 17.1405 13.1207 17.3035L9.5 20.0315V17.6796C9.5 17.3332 9.22016 17.0524 8.875 17.0524H4.5C3.8125 17.0524 3.25 16.488 3.25 15.798V4.50874C3.25 3.81883 3.8125 3.25437 4.5 3.25437H19.5C20.1875 3.25437 20.75 3.81883 20.75 4.50874V15.798ZM12.8633 5.7631H10.9727C9.81641 5.7631 8.875 6.7078 8.875 7.86417C8.875 8.21085 9.15453 8.49135 9.5 8.49135C9.84547 8.49135 10.125 8.21085 10.125 7.86417C10.125 7.3977 10.5039 7.01747 10.9727 7.01747H12.866C13.4219 7.01747 13.875 7.47218 13.875 8.03273C13.875 8.41982 13.6614 8.76771 13.3074 8.94489L11.7109 9.77316C11.5039 9.88292 11.375 10.0985 11.375 10.3298V11.4078C11.375 11.7527 11.6562 12.0349 12 12.0349C12.3438 12.0349 12.625 11.7544 12.625 11.4078V10.7139L13.875 10.0628C14.6465 9.67575 15.125 8.89628 15.125 8.03155C15.125 6.77836 14.1094 5.7631 12.8633 5.7631Z"
        fill="white"
      />
    </svg>
  );
};

export default Help;
